import TextInputMaskedServerError from '@perpay-web/components/higher-order/WithFieldServerErrors/TextInputMaskedServerError';

const DateInput = ({ name = 'date', label = 'Date', ...rest }) => (
    <TextInputMaskedServerError
        name={name}
        id={name}
        label={label}
        format='##/##/####'
        placeholder='MM/DD/YYYY'
        type='tel'
        {...rest}
    />
);

export default DateInput;
